// extracted by mini-css-extract-plugin
module.exports = {"separatedStatusLabel":"styles_separatedStatusLabel__3BaYR","statusMargin":"styles_statusMargin__2Rv4q","statusLabel":"styles_statusLabel__qZCzf"};